import {AdminTypes} from 'types'

// Hierarchy of admin inheritance, admin level in object key also has access to admin levels in value
export const AdminHierarchy: AdminHierarchyType = {
  [AdminTypes.MMB_ADMIN]: [AdminTypes.ORG_ADMIN, AdminTypes.ACCOUNT_ADMIN],
  [AdminTypes.ORG_ADMIN]: [AdminTypes.ACCOUNT_ADMIN],
  [AdminTypes.ACCOUNT_ADMIN]: [],
}

type AdminHierarchyType = {
  [key: string]: AdminTypes[],
}